import { fak, fal } from '@awesome.me/kit-7564db933c/icons';

import { IconLibrary } from '@silae/composables';

export const ICON_LIBRARY: IconLibrary = {
	...fak,
	...fal
};
